export const Countries = {
  CA: {
    label: 'Social Insurance Number',
    placeholder: '000-000-000',
    format: (numbers: string, mask: boolean = false) => {
      if (numbers.length >= 4 && numbers.length < 7) {
        return `${numbers.substr(0, 3)}-${numbers.substr(3)}`
      }

      if (numbers.length > 6) {
        return `${numbers.substr(0, 3)}-${numbers.substr(
          3,
          3
        )}-${numbers.substr(6)}`
      }

      return numbers
    },
  },
  US: {
    label: 'Social Security Number',
    placeholder: '000-00-0000',
    format: (numbers: string, mask: boolean = false) => {
      if (numbers.length >= 4 && numbers.length < 6) {
        return `${numbers.substr(0, 3)}-${numbers.substr(3)}`
      }

      if (numbers.length > 5) {
        if (mask) {
          return `XXX-XX-${numbers.substr(5)}`
        }
        return `${numbers.substr(0, 3)}-${numbers.substr(
          3,
          2
        )}-${numbers.substr(5)}`
      }

      return numbers
    },
  },
  AUS: {
    label: 'ABN',
    placeholder: '00 000 000 000',
    format: (numbers: string, mask: boolean = false) => {
      if (numbers.length >= 3 && numbers.length < 6) {
        return `${numbers.substr(0, 2)} ${numbers.substr(2)}`
      }

      if (numbers.length >= 6 && numbers.length < 9) {
        return `${numbers.substr(0, 2)} ${numbers.substr(
          2,
          3
        )} ${numbers.substr(5)}`
      }

      if (numbers.length > 8) {
        return `${numbers.substr(0, 2)} ${numbers.substr(
          2,
          3
        )} ${numbers.substr(5, 3)} ${numbers.substr(8)}`
      }

      return numbers
    },
  },
}
